import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import About from "./pages/About";
import Authors from "./pages/Authors";
import News from "./pages/News";
import Books from "./pages/Books";
import Videos from "./pages/Videos";
import Contact from "./pages/Contact";
import Submission from "./pages/Submission";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminNewsList from "./pages/admin/AdminNewsList";
import AdminNewsEditor from "./pages/admin/AdminNewsEditor";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminVideosList from "./pages/admin/AdminVideosList";
import AdminVideoEditor from "./pages/admin/AdminVideoEditor";
import AdminBooksList from "./pages/admin/AdminBooksList";
import AdminBookEditor from "./pages/admin/AdminBookEditor";
import AdminSubmissions from "./pages/admin/AdminSubmissions";
import { Toaster } from "./components/ui/sonner";

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {!isAdminRoute && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/news" element={<News />} />
        <Route path="/books" element={<Books />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/authors" element={<Authors />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/submission" element={<Submission />} />
        
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/news" element={<ProtectedRoute><AdminNewsList /></ProtectedRoute>} />
        <Route path="/admin/news/:id" element={<ProtectedRoute><AdminNewsEditor /></ProtectedRoute>} />
        <Route path="/admin/users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
        <Route path="/admin/videos" element={<ProtectedRoute><AdminVideosList /></ProtectedRoute>} />
        <Route path="/admin/videos/:id" element={<ProtectedRoute><AdminVideoEditor /></ProtectedRoute>} />
        <Route path="/admin/books" element={<ProtectedRoute><AdminBooksList /></ProtectedRoute>} />
        <Route path="/admin/books/:id" element={<ProtectedRoute><AdminBookEditor /></ProtectedRoute>} />
        <Route path="/admin/submissions" element={<ProtectedRoute><AdminSubmissions /></ProtectedRoute>} />
      </Routes>
      {!isAdminRoute && <Footer />}
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppContent />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
